import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import Logger from 'services/Logger'
import { isGroupcalApp } from 'utils/appType'

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
}

Logger.pink('Firebase:Config', firebaseConfig)
Logger.pink('Firebase:ApiKey', process.env.REACT_APP_FIREBASE_API_KEY)

export const firebaseApp = initializeApp(firebaseConfig)
export const firebaseAuth = getAuth(firebaseApp)
